import { getAuthHeaders, getAuthToken } from "./authService";

const domain = process.env.REACT_APP_DOMAIN ;

export const getCompany = async () => {
  try {
    const response = await fetch(`${domain}/api/v1/company/get`, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch company details");
    }

    const data = await response.json();
    if (data.success && data.companies?.length > 0) {
      return data.companies[0];
    }

    return null;
  } catch (err) {
    return null;
  }
};

export const getIndustryTemplates = async () => {
  const response = await fetch(`${domain}/api/v1/company/industry-templates`);
  const data = await response.json();
  if (!response.ok) throw new Error(data?.message || "Failed to fetch templates");
  return data;
};

export const createCompany = async (formData) => {
  try {
    const body = new FormData();
    Object.keys(formData).forEach((key) => {
      body.append(key, formData[key]);
    });

    const token = getAuthToken();
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(`${domain}/api/v1/company/create`, {
      method: "POST",
      headers,
      body,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.message || "Failed to create company");
    }

    const data = await response.json();
    return data;
  } catch (err) {
    return { success: false, message: err.message };
  }
};

export const getWebhookInfo = async () => {
  const response = await fetch(`${domain}/api/v1/company/webhook-info`, {
    headers: getAuthHeaders(),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data?.error || "Failed");
  return data;
};

export const regenerateApiKey = async () => {
  const response = await fetch(`${domain}/api/v1/company/regenerate-api-key`, {
    method: "POST",
    headers: getAuthHeaders(),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data?.error || "Failed");
  return data;
};

export const updateCompany = async (companyId, formData) => {
  try {
    const token = getAuthToken();

    // Build FormData (supports text + file uploads)
    const body = new FormData();
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== undefined && formData[key] !== null) {
        body.append(key, formData[key]);
      }
    });

    const response = await fetch(`${domain}/api/v1/company/update/${companyId}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body, // FormData — do NOT set Content-Type manually
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to update company");
    }

    return data;
  } catch (err) {
    return { success: false, message: err.message || "Network error" };
  }
};